"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var _default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/ThemeProvider/nested.js
// module id = 370
// module chunks = 0